// extracted by mini-css-extract-plugin
module.exports = {"outer":"FlexRow_outer__3ZNJY","inner":"FlexRow_inner__2rluv"};